import * as React from 'react'
import { styled } from 'next-yak'

import * as S from '../styles'

export type SkewedBannerProps = React.HTMLAttributes<HTMLDivElement> & {
  skewedBorder?: 'top' | 'bottom'
  children: React.ReactNode
  className?: string
}

function SkewedBannerComponent({
  children,
  skewedBorder = 'bottom',
  className,
  ...props
}: SkewedBannerProps): React.ReactElement<SkewedBannerProps> {
  return (
    <S.container.SkewedContainer className={className} $skewedBorder={skewedBorder} {...props}>
      <S.container.SkewedContent>{children}</S.container.SkewedContent>
    </S.container.SkewedContainer>
  )
}

export const SkewedBanner = styled(SkewedBannerComponent)<SkewedBannerProps>``
SkewedBanner.displayName = 'SkewedBanner'
